import { render, staticRenderFns } from "./Coin2dEdit.vue?vue&type=template&id=981e851e&scoped=true&"
import script from "./Coin2dEdit.vue?vue&type=script&lang=ts&"
export * from "./Coin2dEdit.vue?vue&type=script&lang=ts&"
import style0 from "./Coin2dEdit.vue?vue&type=style&index=0&id=981e851e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981e851e",
  null
  
)

export default component.exports